import qs from "query-string";

import { createSearchApi } from "./common";

const createGlobalSearchApi = (path) => (params) => (token) =>
  createSearchApi("GET", `go_search/${path}?${qs.stringify(params)}`)(token);

export const getGlobalSearchSuppliers = createGlobalSearchApi("suppliers/");
export const getGlobalSearchCustomers = createGlobalSearchApi("customers/");
export const getGlobalSearchSales = createGlobalSearchApi("sales_orders/");
export const getGlobalSearchPurchases = createGlobalSearchApi("purchase_orders/");
export const getGlobalSearchProducts = createGlobalSearchApi("products/");
export const getGlobalSearchAll = createGlobalSearchApi("search/");
export const getGlobalSearchProductsForOrder = createGlobalSearchApi("search_products/");
export const getGlobalSearchOrderItems = createGlobalSearchApi("items/");

export const invalidateGlobalSearchCache = (entity) => () =>
  createSearchApi("POST", `go_search/cache/invalidate/global/${entity}`)();

export default {};
